/**
 * @generated SignedSource<<5d6584f168889ffdc39684efdb4d7b6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "available"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tagsSection"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "available",
    "variableName": "available"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "serviceId",
    "variableName": "serviceId"
  },
  {
    "kind": "Variable",
    "name": "tagsSection",
    "variableName": "tagsSection"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceViewPalacSportuFancyPagesSearchEndpointsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "serviceViewPalacSportuFancyPagesViewer_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "serviceViewPalacSportuFancyPagesSearchEndpointsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "EndpointConnection",
            "kind": "LinkedField",
            "name": "searchEndpoints",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EndpointEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Endpoint",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "filters": [
              "tagsSection",
              "serviceId",
              "available"
            ],
            "handle": "connection",
            "key": "serviceViewPalacSportu_searchEndpoints",
            "kind": "LinkedHandle",
            "name": "searchEndpoints"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0ee9bf24ef94ff3a1dcbfa986d8c3333",
    "id": null,
    "metadata": {},
    "name": "serviceViewPalacSportuFancyPagesSearchEndpointsQuery",
    "operationKind": "query",
    "text": "query serviceViewPalacSportuFancyPagesSearchEndpointsQuery(\n  $after: String\n  $available: Boolean\n  $first: Int!\n  $serviceId: String\n  $tagsSection: String\n) {\n  viewer {\n    ...serviceViewPalacSportuFancyPagesViewer_viewer\n  }\n}\n\nfragment serviceViewPalacSportuFancyPagesViewer_viewer on Viewer {\n  searchEndpoints(first: $first, after: $after, tagsSection: $tagsSection, serviceId: $serviceId, available: $available) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

node.hash = "2c73b1f38e7596a6da11212017360a22";

module.exports = node;
